<script setup>
  import { ref, computed, onMounted } from "vue";
  import MapLegacyInfoWindowFavoriteButton from "@/components/MapLegacyInfoWindowFavoriteButton.vue";
  import { useUserStore } from '@/stores/UserStore';

  const userStore = useUserStore();

  const infoWindowOpened = ref(false);
  const spot = ref(null);

  const showFavoriteButton = computed(() => userStore.userSignedIn && infoWindowOpened.value && spot.value && userStore.currentProfile);

  onMounted(async () => {
    window.$EventBus.addEventListener('info-window-opened', (e) => {
      infoWindowOpened.value = true;
      spot.value = e.detail.spot;
    });
    window.$EventBus.addEventListener('info-window-updated', (e) => {
      spot.value = e.detail.spot;
    });
    window.$EventBus.addEventListener('info-window-closed', () => {
      infoWindowOpened.value = false;
      spot.value = null;
    });

    await userStore.getProfiles();

    if (!userStore.currentProfileId) userStore.setCurrentProfile();
  });
</script>

<template>
  <MapLegacyInfoWindowFavoriteButton v-if="showFavoriteButton" :spot="spot" />
</template>